<template>
  <VcIcon
    name="loading-3quarters"
    path="/static/thorlabs/icons/family-page/"
    size="lg"
    class="spin-animation fill-[--color-neutral-a2]"
  />
</template>

<style lang="scss">
.vc-loader {
  @apply inline-block animate-spin;
}
</style>
